import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTextField } from 'vuetify/lib/components/VTextField';

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VDialog, {
    style: {
      zIndex: 2000
    },
    attrs: {
      persistent: "",
      "max-width": "80%"
    },
    on: {
      keydown: function keydown($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.close();
      }
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c(VCard, [_c("div", {
    staticClass: "dialog-closer --t-2"
  }, [_c(VIcon, {
    staticClass: "far fa-times-circle",
    on: {
      click: function click($event) {
        return _vm.close();
      }
    }
  })], 1), _c(VCardTitle, [_c("span", {
    staticClass: "text-h5"
  }, [_vm._v("Accountancy reconciliations associated to this invoice")])]), _c(VCardText, [!_vm.firstLoaded ? _c("div", {
    staticClass: "text-center mt-default"
  }, [_c(VProgressCircular, {
    attrs: {
      indeterminate: "",
      size: "45",
      width: "3"
    }
  })], 1) : _c("div", _vm._l(_vm.ecOrder.items, function (orderItem) {
    var _vm$associationsByEcI, _vm$associationsByEcI2, _vm$associationsByEcI3, _vm$associationsByEcI4, _vm$associationsByEcI5, _vm$associationsByEcI10, _vm$associationsByEcI11, _vm$associationsByEcI12, _vm$associationsByEcI13, _vm$associationsByEcI14, _vm$associationsByEcI15;
    return _c("div", {
      key: "orderItem-" + orderItem.id_item,
      staticClass: "association-item-container"
    }, [_c("div", [orderItem.quantity === ((_vm$associationsByEcI = (_vm$associationsByEcI2 = _vm.associationsByEcItemId.find(function (x) {
      return x.ecItemId === orderItem.id_item;
    })) === null || _vm$associationsByEcI2 === void 0 || (_vm$associationsByEcI2 = _vm$associationsByEcI2.associations) === null || _vm$associationsByEcI2 === void 0 ? void 0 : _vm$associationsByEcI2.reduce(function (acc, item) {
      return acc + item.nbBottlesAssociated;
    }, 0)) !== null && _vm$associationsByEcI !== void 0 ? _vm$associationsByEcI : 0) ? _c(VIcon, {
      staticClass: "fa fa-check success text-xs"
    }) : ((_vm$associationsByEcI3 = (_vm$associationsByEcI4 = _vm.associationsByEcItemId.find(function (x) {
      return x.ecItemId === orderItem.id_item;
    })) === null || _vm$associationsByEcI4 === void 0 || (_vm$associationsByEcI4 = _vm$associationsByEcI4.associations) === null || _vm$associationsByEcI4 === void 0 ? void 0 : _vm$associationsByEcI4.reduce(function (acc, item) {
      return acc + item.nbBottlesAssociated;
    }, 0)) !== null && _vm$associationsByEcI3 !== void 0 ? _vm$associationsByEcI3 : 0) > 0 ? _c(VIcon, {
      staticClass: "fa fa-percent warning text-xs"
    }) : _c(VIcon, {
      staticClass: "fa fa-percent danger text-xs"
    }), _c("span", {
      staticClass: "text-bold ml-1"
    }, [_vm._v(" " + _vm._s("".concat(orderItem.quantity, " b. ").concat(orderItem.wine.accountancy_code, " :")) + " ")]), _c("span", {
      staticClass: "text-smaller ml-1"
    }, [_vm._v(" " + _vm._s(_vm.wineNaming(_vm.$whitelabel, orderItem.wine.naming_data, true, true)) + " ")])], 1), ((_vm$associationsByEcI5 = _vm.associationsByEcItemId.find(function (x) {
      return x.ecItemId === orderItem.id_item;
    })) === null || _vm$associationsByEcI5 === void 0 || (_vm$associationsByEcI5 = _vm$associationsByEcI5.associations) === null || _vm$associationsByEcI5 === void 0 ? void 0 : _vm$associationsByEcI5.length) > 0 ? _c("div", _vm._l(_vm.associationsByEcItemId.find(function (x) {
      return x.ecItemId === orderItem.id_item;
    }).associations, function (association, index) {
      var _association$payment, _association$payment$, _association$oldPayme, _vm$associationsByEcI6, _vm$associationsByEcI7, _association$payment2, _association$payment$2, _association$oldPayme2, _vm$associationsByEcI8, _vm$associationsByEcI9;
      return _c("div", {
        key: "association-" + association.id + "-" + index
      }, [_c("div", {
        staticClass: "flex gap-2"
      }, [!association.isExternalOcAssociation ? _c("div", [_c(VIcon, {
        staticClass: "fa fa-link text-sm mr-2"
      }), _c("span", {
        staticClass: "text-bold"
      }, [_vm._v(" " + _vm._s("".concat(association.nbBottlesAssociated, " b. on ").concat(association.ocItemData.orderReferenceLabel.shorterReference(), ", ")) + " " + _vm._s("".concat(_vm.formatPrice(association.ocItemData.itemTotalAmountCurrencyIncludeShipping), " ").concat(_vm.getSymbolCurrency(association.ocItemData.currency))) + " " + _vm._s(((_association$payment = association.payment) === null || _association$payment === void 0 ? void 0 : _association$payment.id) > 0 ? " (".concat(((_association$payment$ = association.payment.reference) === null || _association$payment$ === void 0 ? void 0 : _association$payment$.length) > 0 ? association.payment.reference : "#NoRef", ")") : (_association$oldPayme = association.oldPaymentReferences) !== null && _association$oldPayme !== void 0 && _association$oldPayme.length ? " (".concat(association.oldPaymentReferences.join(" , "), " - previous version)") : "") + " ")]), association.isAutomatic && !association.isDirectInboundDeliveryItemAssociation ? _c("span", [_vm._v(" (auto) ")]) : association.isDirectInboundDeliveryItemAssociation ? _c("span", [_vm._v(" (order dispatch) ")]) : _vm._e(), _c("span", [_vm._v(":")]), _c("span", {
        staticClass: "text-smaller"
      }, [_vm._v(" " + _vm._s("".concat(association.ocItemData.orderCustomerDisplayName)) + " ")])], 1) : _c("div", [_c(VIcon, {
        staticClass: "fa fa-link text-sm mr-2"
      }), _c("span", {
        staticClass: "text-bold"
      }, [_vm._v(" " + _vm._s("".concat(association.nbBottlesAssociated, " b. on #").concat(association.externalOcItemData.orderReference, ", ")) + " " + _vm._s("".concat(_vm.formatPrice(association.externalOcItemData.itemTotalAmountCurrencyIncludeShipping), " ").concat(_vm.getSymbolCurrency(association.externalOcItemData.currency))) + " " + _vm._s(association.externalOcItemData.paymentReference ? " (".concat(association.externalOcItemData.paymentReference, ")") : "") + " ")])], 1), !association.isDirectInboundDeliveryItemAssociation && !_vm.updatingForms.some(function (x) {
        return x.associationId === association.id;
      }) ? _c("div", {
        staticClass: "flex gap-2"
      }, [_vm._v(" " + _vm._s(!association.isExternalOcAssociation ? "" : "ExternalOc") + " "), _c(VIcon, {
        staticClass: "fa fa-pen text-sm",
        attrs: {
          disabled: _vm.addingExternalForms.some(function (x) {
            return x.ocItemId === orderItem.id_item;
          }) || _vm.updatingForms.some(function (x) {
            return x.ocItemId === orderItem.id_item;
          }) || _vm.isDeleting.some(function (x) {
            return x.associationId === association.id;
          }),
          title: !association.isExternalOcAssociation ? "Change quantity" : "Edit"
        },
        on: {
          click: function click($event) {
            !association.isExternalOcAssociation ? _vm.openUpdatingForm(association.id, orderItem.id_item) : _vm.openUpdatingExternalForm(association.id, orderItem.id_item);
          }
        }
      }), _c(VIcon, {
        staticClass: "fa fa-trash text-sm",
        attrs: {
          disabled: _vm.addingExternalForms.some(function (x) {
            return x.ocItemId === orderItem.id_item;
          }) || _vm.updatingForms.some(function (x) {
            return x.ocItemId === orderItem.id_item;
          }) || _vm.isDeleting.some(function (x) {
            return x.ocItemId === orderItem.id_item;
          }),
          title: "Delete"
        },
        on: {
          click: function click($event) {
            return _vm.confirmDeleteAssociation(association.id, orderItem.id_item);
          }
        }
      })], 1) : _vm._e()]), _vm.updatingForms.some(function (x) {
        return x.associationId === association.id;
      }) ? [_c("div", {
        staticClass: "subform-bordered"
      }, [_c(VForm, {
        model: {
          value: _vm.updatingForms.find(function (x) {
            return x.associationId === association.id;
          }).isValid,
          callback: function callback($$v) {
            _vm.$set(_vm.updatingForms.find(function (x) {
              return x.associationId === association.id;
            }), "isValid", $$v);
          },
          expression: "updatingForms.find(x => x.associationId === association.id).isValid"
        }
      }, [_c("div", {
        staticClass: "flex gap-2"
      }, [_c("div", {
        staticStyle: {
          width: "4rem"
        }
      }, [_c(VTextField, {
        staticClass: "v-text-field-no-label",
        attrs: {
          autofocus: "",
          type: "number",
          min: 1,
          max: orderItem.quantity - ((_vm$associationsByEcI6 = (_vm$associationsByEcI7 = _vm.associationsByEcItemId.find(function (x) {
            return x.ecItemId === orderItem.id_item;
          })) === null || _vm$associationsByEcI7 === void 0 || (_vm$associationsByEcI7 = _vm$associationsByEcI7.associations) === null || _vm$associationsByEcI7 === void 0 || (_vm$associationsByEcI7 = _vm$associationsByEcI7.filter(function (x) {
            return x.id !== association.id;
          })) === null || _vm$associationsByEcI7 === void 0 ? void 0 : _vm$associationsByEcI7.reduce(function (acc, item) {
            return acc + item.nbBottlesAssociated;
          }, 0)) !== null && _vm$associationsByEcI6 !== void 0 ? _vm$associationsByEcI6 : 0),
          suffix: "b.",
          rules: [_vm.formRules.mustBeGreaterThan0],
          "hide-details": "auto"
        },
        on: {
          keypress: _vm.filterIntegerKey
        },
        model: {
          value: _vm.updatingForms.find(function (x) {
            return x.associationId === association.id;
          }).quantity,
          callback: function callback($$v) {
            _vm.$set(_vm.updatingForms.find(function (x) {
              return x.associationId === association.id;
            }), "quantity", $$v);
          },
          expression: "\n                            updatingForms.find(x => x.associationId === association.id).quantity\n                          "
        }
      })], 1), _c("span", {
        staticClass: "text-bold"
      }, [_vm._v(" " + _vm._s(" on ".concat(association.ocItemData.orderReferenceLabel.shorterReference(), ", ")) + " " + _vm._s("".concat(_vm.formatPrice(association.ocItemData.itemTotalAmountCurrencyIncludeShipping), " ").concat(_vm.getSymbolCurrency(association.ocItemData.currency))) + " " + _vm._s(((_association$payment2 = association.payment) === null || _association$payment2 === void 0 ? void 0 : _association$payment2.id) > 0 ? " (".concat(((_association$payment$2 = association.payment.reference) === null || _association$payment$2 === void 0 ? void 0 : _association$payment$2.length) > 0 ? association.payment.reference : "#NoRef", ")") : (_association$oldPayme2 = association.oldPaymentReferences) !== null && _association$oldPayme2 !== void 0 && _association$oldPayme2.length ? " (".concat(association.oldPaymentReferences.join(" , "), " - previous version)") : "") + " ")]), association.isAutomatic ? _c("span", [_vm._v("(auto)")]) : _vm._e(), _c("span", [_vm._v(":")]), _c("span", {
        staticClass: "text-smaller"
      }, [_vm._v(" " + _vm._s("".concat(association.ocItemData.orderCustomerDisplayName)) + " ")])]), _c("div", {
        staticClass: "mt-3 flex"
      }, [_c(VBtn, {
        staticClass: "dfwa-btn --small-2 secondary",
        attrs: {
          rounded: "",
          disabled: _vm.isUpdating.includes(association.id)
        },
        on: {
          click: function click($event) {
            return _vm.closeUpdatingForm(association.id);
          }
        }
      }, [_c(VIcon, {
        staticClass: "fa fa-times mr-1",
        attrs: {
          size: "0.65rem"
        }
      }), _vm._v(" Cancel ")], 1), _c(VBtn, {
        staticClass: "dfwa-btn --small-2 highlight",
        attrs: {
          rounded: "",
          disabled: !_vm.updatingForms.find(function (x) {
            return x.associationId === association.id;
          }).isValid,
          loading: _vm.isUpdating.includes(association.id)
        },
        on: {
          click: function click($event) {
            return _vm.saveUpdatingForm(association.id);
          }
        }
      }, [_c(VIcon, {
        staticClass: "fa fa-save mr-1",
        attrs: {
          size: "0.65rem"
        }
      }), _vm._v(" Save association ")], 1)], 1)])], 1)] : _vm._e(), _vm.updatingExternalForms.some(function (x) {
        return x.associationId === association.id;
      }) ? [_c("div", {
        staticClass: "subform-bordered"
      }, [_c(VForm, {
        model: {
          value: _vm.updatingExternalForms.find(function (x) {
            return x.associationId === association.id;
          }).isValid,
          callback: function callback($$v) {
            _vm.$set(_vm.updatingExternalForms.find(function (x) {
              return x.associationId === association.id;
            }), "isValid", $$v);
          },
          expression: "\n                      updatingExternalForms.find(x => x.associationId === association.id).isValid\n                    "
        }
      }, [_c("div", {
        staticClass: "flex gap-2"
      }, [_c(VTextField, {
        staticClass: "v-text-field-no-label",
        attrs: {
          prefix: "OC Ref :",
          rules: [_vm.formRules.mustNotBeEmpty],
          placeholder: "External OC reference",
          "hide-details": "auto"
        },
        model: {
          value: _vm.updatingExternalForms.find(function (x) {
            return x.ecItemId === orderItem.id_item;
          }).externalOcReference,
          callback: function callback($$v) {
            _vm.$set(_vm.updatingExternalForms.find(function (x) {
              return x.ecItemId === orderItem.id_item;
            }), "externalOcReference", $$v);
          },
          expression: "\n                          updatingExternalForms.find(x => x.ecItemId === orderItem.id_item)\n                            .externalOcReference\n                        "
        }
      }), _c("div", {
        staticStyle: {
          width: "4rem"
        }
      }, [_c(VTextField, {
        staticClass: "v-text-field-no-label",
        attrs: {
          autofocus: "",
          type: "number",
          min: 1,
          max: orderItem.quantity - ((_vm$associationsByEcI8 = (_vm$associationsByEcI9 = _vm.associationsByEcItemId.find(function (x) {
            return x.ecItemId === orderItem.id_item;
          })) === null || _vm$associationsByEcI9 === void 0 || (_vm$associationsByEcI9 = _vm$associationsByEcI9.associations) === null || _vm$associationsByEcI9 === void 0 || (_vm$associationsByEcI9 = _vm$associationsByEcI9.filter(function (x) {
            return x.id !== association.id;
          })) === null || _vm$associationsByEcI9 === void 0 ? void 0 : _vm$associationsByEcI9.reduce(function (acc, item) {
            return acc + item.nbBottlesAssociated;
          }, 0)) !== null && _vm$associationsByEcI8 !== void 0 ? _vm$associationsByEcI8 : 0),
          suffix: "b.",
          rules: [_vm.formRules.mustBeGreaterThan0],
          "hide-details": "auto"
        },
        on: {
          keypress: _vm.filterIntegerKey
        },
        model: {
          value: _vm.updatingExternalForms.find(function (x) {
            return x.associationId === association.id;
          }).nbBottlesAssociated,
          callback: function callback($$v) {
            _vm.$set(_vm.updatingExternalForms.find(function (x) {
              return x.associationId === association.id;
            }), "nbBottlesAssociated", $$v);
          },
          expression: "\n                            updatingExternalForms.find(x => x.associationId === association.id)\n                              .nbBottlesAssociated\n                          "
        }
      })], 1)], 1), _c("div", [_c(VTextField, {
        staticClass: "v-text-field-no-label required",
        attrs: {
          prefix: "Unit price inc. ship. (".concat(_vm.getSymbolCurrency(_vm.ecOrder.currency), ") :"),
          rules: [_vm.formRules.mustNotBeEmpty],
          placeholder: "Unit price include shipping",
          "hide-details": "auto"
        },
        on: {
          keypress: _vm.filterDecimalKey
        },
        model: {
          value: _vm.updatingExternalForms.find(function (x) {
            return x.associationId === association.id;
          }).ocItemUnitPriceCurrencyIncShipping,
          callback: function callback($$v) {
            _vm.$set(_vm.updatingExternalForms.find(function (x) {
              return x.associationId === association.id;
            }), "ocItemUnitPriceCurrencyIncShipping", $$v);
          },
          expression: "\n                          updatingExternalForms.find(x => x.associationId === association.id)\n                            .ocItemUnitPriceCurrencyIncShipping\n                        "
        }
      }), _c(VTextField, {
        staticClass: "v-text-field-no-label",
        attrs: {
          prefix: "Payment :",
          placeholder: "External OC payment reference",
          "hide-details": "auto"
        },
        model: {
          value: _vm.updatingExternalForms.find(function (x) {
            return x.associationId === association.id;
          }).externalOcPaymentReference,
          callback: function callback($$v) {
            _vm.$set(_vm.updatingExternalForms.find(function (x) {
              return x.associationId === association.id;
            }), "externalOcPaymentReference", $$v);
          },
          expression: "\n                          updatingExternalForms.find(x => x.associationId === association.id)\n                            .externalOcPaymentReference\n                        "
        }
      })], 1), _c("div", {
        staticClass: "mt-3 flex"
      }, [_c(VBtn, {
        staticClass: "dfwa-btn --small-2 secondary",
        attrs: {
          rounded: "",
          disabled: _vm.isUpdatingExternal.includes(association.id)
        },
        on: {
          click: function click($event) {
            return _vm.closeUpdatingExternalForm(association.id);
          }
        }
      }, [_c(VIcon, {
        staticClass: "fa fa-times mr-1",
        attrs: {
          size: "0.65rem"
        }
      }), _vm._v(" Cancel ")], 1), _c(VBtn, {
        staticClass: "dfwa-btn --small-2 highlight",
        attrs: {
          rounded: "",
          disabled: !_vm.updatingExternalForms.find(function (x) {
            return x.associationId === association.id;
          }).isValid,
          loading: _vm.isUpdatingExternal.includes(association.id)
        },
        on: {
          click: function click($event) {
            return _vm.saveUpdatingExternalForm(association.id);
          }
        }
      }, [_c(VIcon, {
        staticClass: "fa fa-save mr-1",
        attrs: {
          size: "0.65rem"
        }
      }), _vm._v(" Save association ")], 1)], 1)])], 1)] : _vm._e()], 2);
    }), 0) : _vm._e(), _vm.addingExternalForms.some(function (x) {
      return x.ecItemId === orderItem.id_item;
    }) ? _c("div", [_vm._v(" add "), _c("div", {
      staticClass: "subform-bordered"
    }, [_c(VForm, {
      model: {
        value: _vm.addingExternalForms.find(function (x) {
          return x.ecItemId === orderItem.id_item;
        }).isValid,
        callback: function callback($$v) {
          _vm.$set(_vm.addingExternalForms.find(function (x) {
            return x.ecItemId === orderItem.id_item;
          }), "isValid", $$v);
        },
        expression: "addingExternalForms.find(x => x.ecItemId === orderItem.id_item).isValid"
      }
    }, [_c("div", {
      staticClass: "flex gap-2"
    }, [_c("div", [_c(VIcon, {
      staticClass: "fa fa-link text-sm"
    }), _c("div", {
      staticStyle: {
        position: "absolute",
        top: "-6px",
        right: "-5px"
      }
    }, [_c(VIcon, {
      staticClass: "fa fa-plus success",
      attrs: {
        size: "0.4rem"
      }
    })], 1)], 1), _c(VTextField, {
      staticClass: "v-text-field-no-label",
      attrs: {
        rules: [_vm.formRules.mustNotBeEmpty],
        prefix: "OC Ref :",
        placeholder: "External OC reference",
        "hide-details": "auto"
      },
      model: {
        value: _vm.addingExternalForms.find(function (x) {
          return x.ecItemId === orderItem.id_item;
        }).externalOcReference,
        callback: function callback($$v) {
          _vm.$set(_vm.addingExternalForms.find(function (x) {
            return x.ecItemId === orderItem.id_item;
          }), "externalOcReference", $$v);
        },
        expression: "\n                      addingExternalForms.find(x => x.ecItemId === orderItem.id_item)\n                        .externalOcReference\n                    "
      }
    }), _c("div", {
      staticStyle: {
        width: "4rem"
      }
    }, [_c(VTextField, {
      staticClass: "v-text-field-no-label",
      attrs: {
        autofocus: "",
        type: "number",
        min: 1,
        max: orderItem.quantity - ((_vm$associationsByEcI10 = (_vm$associationsByEcI11 = _vm.associationsByEcItemId.find(function (x) {
          return x.ecItemId === orderItem.id_item;
        })) === null || _vm$associationsByEcI11 === void 0 || (_vm$associationsByEcI11 = _vm$associationsByEcI11.associations) === null || _vm$associationsByEcI11 === void 0 ? void 0 : _vm$associationsByEcI11.reduce(function (acc, item) {
          return acc + item.nbBottlesAssociated;
        }, 0)) !== null && _vm$associationsByEcI10 !== void 0 ? _vm$associationsByEcI10 : 0),
        suffix: "b.",
        rules: [_vm.formRules.mustBeGreaterThan0],
        "hide-details": "auto"
      },
      on: {
        keypress: _vm.filterIntegerKey
      },
      model: {
        value: _vm.addingExternalForms.find(function (x) {
          return x.ecItemId === orderItem.id_item;
        }).nbBottlesAssociated,
        callback: function callback($$v) {
          _vm.$set(_vm.addingExternalForms.find(function (x) {
            return x.ecItemId === orderItem.id_item;
          }), "nbBottlesAssociated", $$v);
        },
        expression: "\n                        addingExternalForms.find(x => x.ecItemId === orderItem.id_item)\n                          .nbBottlesAssociated\n                      "
      }
    })], 1)], 1), _c("div", [_c(VTextField, {
      staticClass: "v-text-field-no-label required",
      attrs: {
        prefix: "Unit price inc. ship. (".concat(_vm.getSymbolCurrency(_vm.ecOrder.currency), ") :"),
        rules: [_vm.formRules.mustNotBeEmpty],
        placeholder: "Unit price include shipping",
        "hide-details": "auto"
      },
      on: {
        keypress: _vm.filterDecimalKey
      },
      model: {
        value: _vm.addingExternalForms.find(function (x) {
          return x.ecItemId === orderItem.id_item;
        }).ocItemUnitPriceCurrencyIncShipping,
        callback: function callback($$v) {
          _vm.$set(_vm.addingExternalForms.find(function (x) {
            return x.ecItemId === orderItem.id_item;
          }), "ocItemUnitPriceCurrencyIncShipping", $$v);
        },
        expression: "\n                      addingExternalForms.find(x => x.ecItemId === orderItem.id_item)\n                        .ocItemUnitPriceCurrencyIncShipping\n                    "
      }
    }), _c(VTextField, {
      staticClass: "v-text-field-no-label",
      attrs: {
        prefix: "Payment :",
        placeholder: "External OC payment reference",
        "hide-details": "auto"
      },
      model: {
        value: _vm.addingExternalForms.find(function (x) {
          return x.ecItemId === orderItem.id_item;
        }).externalOcPaymentReference,
        callback: function callback($$v) {
          _vm.$set(_vm.addingExternalForms.find(function (x) {
            return x.ecItemId === orderItem.id_item;
          }), "externalOcPaymentReference", $$v);
        },
        expression: "\n                      addingExternalForms.find(x => x.ecItemId === orderItem.id_item)\n                        .externalOcPaymentReference\n                    "
      }
    })], 1), _c("div", {
      staticClass: "mt-3 flex"
    }, [_c(VBtn, {
      staticClass: "dfwa-btn --small-2 secondary",
      attrs: {
        disabled: _vm.isAddingExternal.includes(orderItem.id_item),
        rounded: ""
      },
      on: {
        click: function click($event) {
          return _vm.closeAddingExternalForm(orderItem.id_item);
        }
      }
    }, [_c(VIcon, {
      staticClass: "fa fa-times mr-1",
      attrs: {
        size: "0.65rem"
      }
    }), _vm._v(" Cancel ")], 1), _c(VBtn, {
      staticClass: "dfwa-btn --small-2 highlight",
      attrs: {
        disabled: !_vm.addingExternalForms.find(function (x) {
          return x.ecItemId === orderItem.id_item;
        }).isValid,
        loading: _vm.isAddingExternal.includes(orderItem.id_item),
        rounded: ""
      },
      on: {
        click: function click($event) {
          return _vm.saveAddingExternalForm(orderItem.id_item);
        }
      }
    }, [_c(VIcon, {
      staticClass: "fa fa-save mr-1",
      attrs: {
        size: "0.65rem"
      }
    }), _vm._v(" Create association ")], 1)], 1)])], 1)]) : orderItem.quantity > ((_vm$associationsByEcI12 = (_vm$associationsByEcI13 = _vm.associationsByEcItemId.find(function (x) {
      return x.ecItemId === orderItem.id_item;
    })) === null || _vm$associationsByEcI13 === void 0 || (_vm$associationsByEcI13 = _vm$associationsByEcI13.associations) === null || _vm$associationsByEcI13 === void 0 ? void 0 : _vm$associationsByEcI13.reduce(function (acc, item) {
      return acc + item.nbBottlesAssociated;
    }, 0)) !== null && _vm$associationsByEcI12 !== void 0 ? _vm$associationsByEcI12 : 0) ? _c("div", [_c("div", [_c(VBtn, {
      staticClass: "dfwa-btn --small-2 secondary",
      attrs: {
        disabled: _vm.updatingForms.some(function (x) {
          return x.ecItemId === orderItem.id_item;
        }) || _vm.updatingExternalForms.some(function (x) {
          return x.ecItemId === orderItem.id_item;
        }) || _vm.isDeleting.some(function (x) {
          return x.ecItemId === orderItem.id_item;
        }),
        rounded: ""
      },
      on: {
        click: function click($event) {
          return _vm.openExternalFormForItem(orderItem.id_item);
        }
      }
    }, [_c(VIcon, {
      staticClass: "fa fa-plus mr-1",
      attrs: {
        size: "0.65rem"
      }
    }), _vm._v(" Add external association ")], 1)], 1), _c("div", [_c("span", {
      staticClass: "text-smaller text-italic"
    }, [_vm._v(" " + _vm._s(orderItem.quantity - ((_vm$associationsByEcI14 = (_vm$associationsByEcI15 = _vm.associationsByEcItemId.find(function (x) {
      return x.ecItemId === orderItem.id_item;
    })) === null || _vm$associationsByEcI15 === void 0 || (_vm$associationsByEcI15 = _vm$associationsByEcI15.associations) === null || _vm$associationsByEcI15 === void 0 ? void 0 : _vm$associationsByEcI15.reduce(function (acc, item) {
      return acc + item.nbBottlesAssociated;
    }, 0)) !== null && _vm$associationsByEcI14 !== void 0 ? _vm$associationsByEcI14 : 0)) + " bottle(s) not reconcilied ")])])]) : _vm._e()]);
  }), 0)]), _c(VCardActions, {
    staticClass: "actions-bottom-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: "",
      loading: _vm.isLoadingAssociations
    },
    on: {
      click: function click($event) {
        return _vm.close();
      }
    }
  }, [_vm._v(" Close ")])], 1)], 1), _c("Confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };